//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const PaymentButtonTextOverride: FeatureFlag = {"Id":"PaymentButtonTextOverride","Label":"(KILL)[10.27]PaymentButtonTextOverride","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch for EB-756's fix to the Payment add-in's submit button text. When active, the Payment add-in's payment-owed text (default \"Continue to Payment\" or custom) overrides a Workflow's single Button and a plain form's submit button, and is skipped when the page has more than one Button. When disabled, the previous behavior is preserved.","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
